import { render, staticRenderFns } from "./PUploadDropzone.vue?vue&type=template&id=6bd97dc4&scoped=true"
import script from "./PUploadDropzone.vue?vue&type=script&lang=js"
export * from "./PUploadDropzone.vue?vue&type=script&lang=js"
import style0 from "./PUploadDropzone.vue?vue&type=style&index=0&id=6bd97dc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd97dc4",
  null
  
)

export default component.exports